import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bafe67a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Sorry! No estimates available.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Unfortunately, no nearby shops were able to provide an estimate for the service you requested. Would you like to be notified when more shops in your area join Openbay? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "no-offers-form form-float",
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.createBetaContact()), ["stop","prevent"]))
  }, [
    _createElementVNode("img", {
      src: _ctx.asset(require(`@/assets/images/no_shop_placeholder@2x.png`)),
      alt: "Choose or describe your service",
      class: "img-fluid"
    }, null, 8, _hoisted_1),
    _hoisted_2,
    _hoisted_3
  ], 32))
}